import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify'; 
import awsconfig from './aws-exports';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { CartProvider } from './components/CartContext';

Amplify.configure(awsconfig); // Initialize Amplify with the configuration

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    
    <CartProvider>
      <App />
    </CartProvider>
  
);
